import './app/service/topdata-contact-login-search-type';
import './module/sw-customer/view/sw-customer-detail-contacts/sw-customer-detail-contacts';
import './module/topdata-contact-login-customer-extension';
import './module/topdata-contact-login-customer-extension/override/sw-customer-detail';

// Register the new components
import TopdataConvertCustomerModal from './module/topdata-contact-login-list/component/topdata-convert-customer-modal';
Shopware.Component.register('topdata-convert-customer-modal', TopdataConvertCustomerModal);

import './module/topdata-contact-login-list';
import './module/topdata-contact-login-reg-log';
import './module/topdata-contact-login-attempt-log';
import './module/topdata-contact-login-conversion-log';
